import { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { Globe } from '@phosphor-icons/react';

const languages = [
  { code: 'ru', label: 'RU', name: 'Русский' },
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'es', label: 'ES', name: 'Español' },
  { code: 'zh', label: '中文', name: '中文' },
  { code: 'fr', label: 'FR', name: 'Français' },
];

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const currentLang = languages.find((lang) => lang.code === language);

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        data-testid="language-switcher-button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-zinc-400 hover:text-gold transition-colors duration-300 text-sm uppercase tracking-wider"
      >
        <Globe size={20} weight="thin" />
        <span>{currentLang?.label}</span>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full right-0 mt-2 bg-[#121212] border border-zinc-800 z-50 min-w-[150px]">
            {languages.map((lang) => (
              <button
                key={lang.code}
                data-testid={`language-option-${lang.code}`}
                onClick={() => {
                  setLanguage(lang.code);
                  setIsOpen(false);
                }}
                className={`w-full text-left px-4 py-3 text-sm transition-colors duration-200 ${
                  language === lang.code
                    ? 'bg-gold/10 text-gold'
                    : 'text-zinc-400 hover:bg-zinc-900 hover:text-gold'
                }`}
              >
                {lang.name}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
